import ArrowIcon from "../../Assets/Images/Arrow.svg";
import ClientElement2 from "../../Assets/Images/internation-client-1.png";
import ClientElement3 from "../../Assets/Images/internation-client-2.png";
import promisesImage from "../../Assets/Images/promises.png";
import bannerImage1 from "../../Assets/Images/about-us-banner.png";
import bannerImage2 from "../../Assets/Images/about-us-banner-2.png";
import bannerBarImage1 from "../../Assets/Images/about-us-banner-bar-3.png";
import bannerBarImage2 from "../../Assets/Images/about-us-banner-bar-4.png";
import aicLeftBannerImage from "../../Assets/Images/International-Clients-1920.png";
import interMobImage from "../../Assets/Images/Inter-Mob.png";
import { Col, Container, Row } from "reactstrap";
import { americanGlobalFidelity } from "../../constants/DummyValueConstants";
import FAQs from "../../Components/FAQs";
import HealthInsuranceHero from "../../Components/HealthInsuranceHero";
import GlobalFidelity from "../../Components/GlobalFidelity";
import OurPromise from "../../Components/OurPromise";
import "./About.css";
import NavBar from "../../Components/NavBar";
import AmBest from "../../Components/AmBest/AmBest";
import { useRef, useState } from "react";
import Great from "../../Components/Great/Great";
import Ward from "../../Components/Ward/Ward";
import InternationalClientsData from "./InternationalClientsData";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

import bannerMobileImage2 from "../../Assets/Images/about-us-banner-mobile-2.png";
import aboutUsHero1280 from "../../Assets/Images/About-us-12802x.png";
import aboutUsHero1920 from "../../Assets/Images/About-Us-1921-2500.png";

const componentMap = {
  AM: <AmBest />,
  Ward: <Ward />,
  Great: <Great />,
};

const About = () => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();

  const [change, setChange] = useState("AM");
  // Reference to the scroll target section
  const scrollToRef = useRef(null);

  // Scroll handler
  const scrollToContent = () => {
    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <NavBar />
      <div className="about-wrap">
        <div className="about-top md:min-h-screen bg-[#0D4248] flex justify-center items-center md:items-end xl:items-center text-white text-xl relative">
          <Container>
            <Row
              id="about-top-banner"
              className="flex flex-col lg:flex-row  md:space-x-12"
            >
              <Col lg={4} className="flex-1 lg:order-1 order-2 z-10">
                <div className="about-content-top">
                  <div className="max-w-[445px] reveal-up md:px-0 pl-4 about-inner-content">
                    <h1 className="leading-tight text-[20px] md:text-[28px] md:leading-[32px] xl:text-4xl xl:leading-tight font-semibold extra-title-heading">
                      {translations.aboutUsBannerTitle}
                    </h1>
                    <p className="hidden max-w-[384px] lg:block text-[1rem] leading-normal md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-normal mt-4 extra-para-vs">
                      {translations.aboutUsBannerDescription}
                    </p>
                    <p className="block lg:hidden leading-relaxed text-[14px] mt-4 extra-para-vs">
                      {translations.aboutUsBannerDescription}
                    </p>
                  </div>
                  <div className="container z-[4] mt-5 md:mt-[100px] lg:absolute lg:left-0 lg:right-0 lg:bottom-16 lg:mt-0 flex gap-3 items-center arrow-about-banner">
                    <div
                      className="arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
                      onClick={scrollToContent}
                    >
                      <img
                        src={ArrowIcon}
                        alt="AFGSL"
                        className="logo animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                      />
                    </div>
                    <p className="text-sm mb-0 lg:block hidden ">
                      {" "}
                      {translations.aboutUsBannerButton}
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={8} className="relative flex-1 lg:order-2 order-1">
                <div className="right-images flex image-section">
                  {/* Mobile + Tablet (≤1023): legacy 4-image layout */}
                  <img
                    src={bannerImage2}
                    alt="about-us-banner-image"
                    className="image-section-banner-2 hidden md:block lg:hidden"
                  />
                  <img
                    src={bannerMobileImage2}
                    alt="about-us-banner-image"
                    className="image-section-banner-2 md:hidden block"
                  />
                  <img
                    src={bannerImage1}
                    alt="about-us-banner-image"
                    className="image-section-banner-1 lg:hidden"
                  />
                  <img
                    src={bannerBarImage1}
                    alt="about-us-banner-image"
                    className="image-section-banner-3 absolute lg:hidden"
                  />
                  <img
                    src={bannerBarImage2}
                    alt="about-us-banner-image"
                    className="image-section-banner-4 absolute lg:hidden"
                  />

                  {/* Laptop small + Laptop (1024-1919): single composite image */}
                  <img
                    src={aboutUsHero1280}
                    alt="about-us-hero"
                    className="about-us-hero-image hidden lg:block [@media(min-width:1920px)]:hidden"
                  />

                  {/* Desktop 1920+: single composite image */}
                  <img
                    src={aboutUsHero1920}
                    alt="about-us-hero"
                    className="about-us-hero-image hidden [@media(min-width:1920px)]:block"
                  />
                </div>
              </Col>
            </Row>
            <div
              id="american-fidelity"
              className="flex flex-col justify-space-between md:flex-row lg:space-x-3 mt-12 lg:pt-[60px] [@media(min-width:1920px)]:pt-40 mb-8 pt-12 pb-12 lg:pb-32 [@media(min-width:1920px)]:pb-40 lg:pl-0 px-4"
            >
              <div
                sm={12}
                lg={6}
                md={6}
                className="mt-5 pt-5 flex-1 xl:flex-2 md:pe-3 z-10 american-fidelity-left-col reveal-up"
              >
                {/* <p className="text-sm mb-2 lg:hidden block">Back up</p> */}
                <h3 className="md:text-[27px] md:leading-[33px] xl:text-[36px] xl:leading-[44px] text-[24px] leading-[28px] tracking-tight font-semibold mb-6">
                  {translations.americanfidelityTitle}
                </h3>
                <p className="text-[14px] leading-[22px] text-left md:text-[12px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] mb-8 extra-para-vs max-w-[592px] tracking-tight">
                  {translations.americanfidelityDescription2}
                </p>
                <div className="block w-[28px] h-[2px] bg-[#ED1C2C] mb-6"></div>
                <p
                  className="american-fidelity-pillars text-[18px] leading-[26px] md:text-[18px] md:leading-[26px] xl:text-[22px] xl:leading-[32px] [@media(min-width:1920px)]:!text-[28px] [@media(min-width:1920px)]:!leading-[38px] mb-8 max-w-[592px] font-semibold tracking-tight"
                  dangerouslySetInnerHTML={{
                    __html: translations.americanfidelityDescription,
                  }}
                />
                <p className="md:text-[11px] md:leading-[16px] xl:text-[13px] xl:leading-[20px] text-[12px] leading-[18px] tracking-tight mb-0 opacity-90">
                  {translations.americanfidelityAmount}
                </p>
              </div>
              <div sm={12} lg={6} md={6} className="mt-5 pt-5 flex-1">
                <ul className="list-none american-fidelity-right-col max-w-[450px] md:ms-auto">
                  <li className="border-b-[1px] border-[#53BCC8] lg:pb-6 pb-6 flex items-center reveal-up reveal-delay-1 lg:px-0 px-2">
                    <div className="text-[1.5rem] md:text-[1.875rem] md:leading-[2rem] xl:text-[2.5rem] xl:leading-[2.5rem] font-semibold tracking-tight flex-none w-[120px] md:w-[160px] lg:w-[120px] xl:w-[160px] aff-numbers">
                      $ 1.3 B<sup className="lg:inline-block">*</sup>{" "}
                    </div>
                    <div className="text-[16px] leading-[22px] md:text-[12px] md:leading-[17px] xl:text-[16px] xl:leading-[22px] pl-0 md:pl-3 pl-md-5 lg:pb-0 aff-numbers-content">
                      <span
                        className="lg:block hidden"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextOne,
                        }}
                      ></span>
                      <span
                        className="lg:hidden block"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextOne,
                        }}
                      ></span>
                    </div>
                  </li>
                  <li className="border-b-[1px]  lg:border-[#53BCC8] border-[#FFE9B1] lg:pb-6 pb-6 lg:pt-6 pt-6 flex items-center reveal-up reveal-delay-2 lg:px-0 px-2">
                    <div className="text-[1.5rem] md:text-[1.875rem] md:leading-[2rem] xl:text-[2.5rem] xl:leading-[2.5rem] font-semibold tracking-tight flex-none w-[120px] md:w-[160px] lg:w-[120px] xl:w-[160px] aff-numbers">
                      $ 16.2 B<sup className="lg:inline-block">*</sup>
                    </div>
                    <div className="text-[16px] leading-[22px] md:text-[12px] md:leading-[17px] xl:text-[16px] xl:leading-[22px] pl-0 md:pl-3 pl-md-5 lg:pb-0 aff-numbers-content">
                      <span
                        className="lg:block hidden"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextTwo,
                        }}
                      ></span>
                      <span
                        className="lg:hidden block"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextTwo,
                        }}
                      ></span>
                    </div>
                  </li>
                  <li
                    className="flex lg:pb-6 pb-6 lg:pt-6 pt-6 flex items-center reveal-up reveal-delay-3 lg:px-0 px-2"
                    ref={scrollToRef}
                  >
                    <div className="text-[1.5rem] md:text-[1.875rem] md:leading-[2rem] xl:text-[2.5rem] xl:leading-[2.5rem] font-semibold tracking-tight flex-none w-[120px] md:w-[160px] lg:w-[120px] xl:w-[160px] aff-numbers">
                      $ 240 M<sup className="">*</sup>
                    </div>
                    <div className="text-[16px] leading-[22px] md:text-[12px] md:leading-[17px] xl:text-[16px] xl:leading-[22px] pl-0 md:pl-3 pl-md-5 aff-numbers-content">
                      <span
                        className="lg:block hidden"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextThree,
                        }}
                      ></span>
                      <span
                        className="lg:hidden block"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextThree,
                        }}
                      ></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Container>
        </div>

        <div
          id="values-guide-us"
          className="supeior-rating py-20 pb-12 lg:py-36"
        >
          <Container>
            <div className="flex justify-between lg:space-x-4 lg:flex-row flex-col ">
              <div className="flex-1 reveal-up mt-0 lg:mt-28 lg:pl-0 pl-4 lg:max-w-[302px] xl:max-w-[460px] [@media(min-width:1920px)]:max-w-[460px]">
                <p className="text-sm md:text-[10.5px] md:leading-[14.7px] md:tracking-[-0.21px] xl:text-sm xl:leading-normal xl:tracking-normal text-gray-600 mb-1 learnmoreacc">
                  {translations.historyLearnMore}
                </p>
                <h3 className="md:text-[30px] md:leading-[33px] md:tracking-[-0.6px] xl:text-[40px] xl:leading-[44px] xl:tracking-tight font-semibold mb-4 text-[24px] leading-[28px] tracking-tight lg:max-w-[252px] xl:max-w-none extra-title-heading [@media(min-width:1920px)]:!text-[44px] [@media(min-width:1920px)]:!leading-[50px]">
                  {translations.valuesHeading}
                </h3>
                <p className="text-sm lg:block hidden mb-8 extra-para-vs md:text-[11.5px] md:leading-[18px] lg:w-[239px] xl:text-sm xl:leading-normal xl:w-[460px] [@media(min-width:1920px)]:w-[460px]">
                  {translations.valuesDescription}
                </p>
                <div className="active-section flex lg:justify-center justify-space-between gap-2 bg-white rounded-full lg:mr-0 mr-4 lg:mt-4 mt-8 mb-4 max-w-[420px] lg:max-w-[284px] xl:max-w-[420px]">
                  <button
                    onClick={() => setChange("AM")}
                    className={`flex-1 content text-[12px] md:text-[12px] md:leading-[16.8px] md:tracking-[-0.24px] xl:text-[14px] xl:leading-normal xl:tracking-normal extra-btn-font ${
                      change === "AM" ? "active bg-[#0D4248]" : ""
                    } font-medium  ${
                      change === "AM" ? "text-white" : "text-black"
                    } py-3 lg:py-2 xl:py-3 px-4 lg:px-3 xl:px-4 rounded-full`}
                  >
                    {translations.valuesAMBestTab}
                  </button>
                  <button
                    onClick={() => setChange("Ward")}
                    className={`flex-1 content text-[12px] md:text-[12px] md:leading-[16.8px] md:tracking-[-0.24px] xl:text-[14px] xl:leading-normal xl:tracking-normal extra-btn-font ${
                      change === "Ward" ? "active bg-[#0D4248]" : ""
                    } font-medium  ${
                      change === "Ward" ? "text-white" : "text-black"
                    } py-3 lg:py-2 xl:py-3 px-4 lg:px-3 xl:px-4 rounded-full`}
                  >
                    <span className="hidden md:block">
                      {translations.valuesWardsTab}
                    </span>
                    <span className="block md:hidden">
                      {translations.valuesWardsTab} 50
                    </span>
                  </button>
                  <button
                    onClick={() => setChange("Great")}
                    className={`flex-2 content text-[12px] md:text-[12px] md:leading-[16.8px] md:tracking-[-0.24px] xl:text-[14px] xl:leading-normal xl:tracking-normal extra-btn-font ${
                      change === "Great" ? "active bg-[#0D4248]" : ""
                    } font-medium  ${
                      change === "Great" ? "text-white" : "text-black"
                    } py-3 lg:py-2 xl:py-3 px-4 lg:px-3 xl:px-4 rounded-full`}
                  >
                    <span className="hidden md:block">
                      {translations.valuesOtherRewardsTab}
                    </span>
                    <span className="block md:hidden">Great Place to Work</span>
                  </button>
                </div>
              </div>
              {componentMap[change] || null}
            </div>
          </Container>
        </div>

        {/* International Clients section — clean flex layout. At lg+ image is
            on the right (overflows past viewport). At <lg the order is:
            Title → Image → Text content (per Figma). */}
        <div
          id="about-international-client-id"
          className="about-international-client bg-[#F7F6F2] py-16 md:py-20 overflow-hidden"
        >
          <div className="container">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
              {/* Mobile + Tablet only: Title at the top */}
              <div className="block lg:hidden w-full px-4 md:px-0">
                <h2 className="text-[24px] leading-[28px] tracking-[-0.48px] md:text-[30px] md:leading-[33px] md:tracking-[-0.6px] font-semibold mb-6 FAQheading">
                  {translations.internationalHeading}
                </h2>
              </div>
              {/* Mobile + Tablet only: Capsule image
                  - Mobile: image extends past the RIGHT edge per Figma (right-aligned crop)
                  - Tablet: image left-aligned (matching Values/AmBest), full oval visible */}
              <div className="block lg:hidden w-full -mr-4 md:mr-0 md:pl-4 md:max-w-[664px] overflow-hidden md:overflow-visible flex mb-6">
                <img
                  src={interMobImage}
                  alt="International Clients"
                  className="w-[130%] md:w-full max-w-none md:max-w-full h-auto reveal-up"
                />
              </div>
              {/* Text content column */}
              <div className="w-full lg:w-2/5">
                <div className="aic-content">
                  <InternationalClientsData />
                </div>
              </div>
              {/* Desktop only: Image on the right (overflows past viewport edge) */}
              <div className="hidden lg:block lg:w-3/5 lg:relative">
                <img
                  src={aicLeftBannerImage}
                  alt="International Client Element"
                  className="w-full lg:!max-w-none lg:w-[140%] [@media(min-width:1920px)]:w-[130%] h-auto object-cover reveal-up"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="health ">
          <HealthInsuranceHero pageName="about" />
        </div>
      </div>
    </>
  );
};

export default About;
